import { toZonedTime } from 'date-fns-tz'

const PARIS_TZ = 'Europe/Paris'

/**
 * Checks if a deadline date falls on a day that cannot be handled before
 * Monday EOD — i.e. Saturday, Sunday, or Monday (Paris TZ).
 */
export function isDeadlineCriticalForWeekend(deadline: Date): boolean {
  const paris = toZonedTime(deadline, PARIS_TZ)
  const day = paris.getDay() // 0=Sun, 1=Mon, 6=Sat
  return day === 0 || day === 1 || day === 6
}

/**
 * Checks if a deadline date falls on a Saturday or Sunday (Paris TZ).
 */
export function isDeadlineOnWeekend(deadline: Date): boolean {
  const paris = toZonedTime(deadline, PARIS_TZ)
  const day = paris.getDay()
  return day === 0 || day === 6
}

/**
 * Checks if the current time (Paris TZ) is within the weekend alert window:
 * Saturday >= 11:30 through end of Sunday 23:59.
 */
export function isWeekendAlertWindow(now: Date = new Date()): boolean {
  const paris = toZonedTime(now, PARIS_TZ)
  const day = paris.getDay() // 0=Sun, 6=Sat

  if (day === 0) return true
  if (day === 6) {
    const hours = paris.getHours()
    const minutes = paris.getMinutes()
    return hours > 11 || (hours === 11 && minutes >= 30)
  }
  return false
}

/**
 * Returns true if both weekend booking alert conditions are met:
 * 1. Current time is in the weekend alert window (Sat >= 11:30 or Sun)
 * 2. The LD or OPW falls on a Saturday, Sunday, or Monday
 */
export function shouldTriggerWeekendAlert(params: {
  fareValidityDeadline: Date | null
  now?: Date
  ticketingDeadline: Date | null
}): boolean {
  if (!isWeekendAlertWindow(params.now)) return false

  const ld = params.ticketingDeadline
  const opw = params.fareValidityDeadline

  return (
    (ld !== null && isDeadlineCriticalForWeekend(ld)) ||
    (opw !== null && isDeadlineCriticalForWeekend(opw))
  )
}
